export const baseURL = process.env.VUE_APP_API_URL;

export const languages = [{ locale: "ca", title: "CA" }];
